import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MenuProvider } from "../../../../../../../../../../../services/Api/Organization/types";
import { RenderOrderSourceLogo } from "../../../../../../../../../../../utils/orders/RenderOrderSourceLogo";

interface Props {
	provider: MenuProvider;
	selected: boolean;
	setSelectedProvider: React.Dispatch<React.SetStateAction<MenuProvider | undefined>>;
}

const MenuExternalPortalOption = ({ provider, selected, setSelectedProvider }: Props) => {
	const { t } = useTranslation();

	return (
		<Card
			className={`mb-0 cursor-pointer external-provider-option ${selected ? "--selected" : ""}`}
			onClick={() => setSelectedProvider(provider)}
		>
			<Card.Body className="px-2 py-1">
				<div className="d-flex align-items-center">
					<RenderOrderSourceLogo source={provider} variant="small" />
					<p className="mb-0 ms-2">{t(`enums.menu.external_portal.${provider}`)}</p>
				</div>
			</Card.Body>
		</Card>
	);
};

export default MenuExternalPortalOption;

// t('enums.menu.external_portal.UBER')
// t('enums.menu.external_portal.GLOVO')
// t('enums.menu.external_portal.WOLT')
// t('enums.menu.external_portal.TAKEAWAYV2')
// t('enums.menu.external_portal.BOLT')
